
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#12181D","d":"M22.328 5.5a.5.5 0 01.5.5v2.227h1.328a.5.5 0 01.492.41l.008.09v3.637a4.144 4.144 0 01-3.658 4.107l.003.025.028 3.762A5.742 5.742 0 0115.287 26h-.798a4.986 4.986 0 01-4.915-4.156.458.458 0 01-.028-.124l-.03-.364-.008-.159a17.045 17.045 0 01-.03-1.98c-1.944-.302-2.6-1.846-1.904-3.567l.073-.17c.293-.646.615-1.077 1.275-1.783l.377-.398c.84-.894 1.178-1.37 1.502-2.21a.5.5 0 01.74-.24c1.807 1.183 3.254 4.527 2.865 6.429-.44 2.157-1.974 3.312-3.94 2.338-.01.4 0 .83.026 1.294l.01.053.007.22.02.267a3.986 3.986 0 003.96 3.55h.798a4.742 4.742 0 004.737-4.524l.005-.254-.028-3.719.002-.032a4.144 4.144 0 01-3.658-4.107V8.727a.5.5 0 01.5-.5h1.327V6a.5.5 0 111 0v2.227h2.656V6a.5.5 0 01.5-.5zm-10.864 6.566l-.072.143c-.308.58-.698 1.065-1.353 1.762l-.375.397-.321.352c-.383.436-.594.753-.785 1.173-.546 1.203-.238 2.112 1.02 2.33a6.583 6.583 0 011.166-2.875.5.5 0 11.818.575c-.56.796-.872 1.612-1.011 2.59 1.506.97 2.528.266 2.876-1.435.26-1.272-.62-3.584-1.792-4.838l-.17-.174zm12.192-2.839h-6.311v3.137a3.145 3.145 0 002.977 3.131l.179.005a3.146 3.146 0 003.155-3.136V9.227z"}})])
          )
        }
      }
    